import { PaymentType } from "src/api";
import { useDepositWithdrawContext } from "src/contexts";
import { _t } from "src/utils/translation";

interface UsePaymentValidationProps {
  amount: number;
  paymentType: PaymentType;
  fee?: number;
}

export const usePaymentValidation = ({ amount, paymentType, fee = 0 }: UsePaymentValidationProps) => {
  const { paymentsLimits, balance } = useDepositWithdrawContext();
  const {
    currency: { currency_id },
    free_balance,
  } = balance;

  const minAmount =
    paymentType === PaymentType.Deposit ? paymentsLimits.deposit_min_amount : paymentsLimits.withdrawal_min_amount;
  const minAmountError = amount && amount < minAmount;

  const notEnoughBalance = paymentType === PaymentType.Withdrawal && amount && free_balance < amount;

  const amountAfterFeeError = amount && fee && amount - fee <= 0;

  const paymentValidationErrors = [
    minAmountError
      ? [
          _t("VALIDATION.MINIMUM_AMOUNT", {
            paymentType,
            minAmount,
            currency: currency_id,
          }),
        ]
      : [],
    notEnoughBalance
      ? [
          _t("VALIDATION.NOT_ENOUGH_BALANCE", {
            balance: free_balance,
          }),
        ]
      : [],
    amountAfterFeeError
      ? [
          _t("VALIDATION.AMOUNT_AFTER_FEE_SHOULD_BE_GREATER_THAN_ZERO"),
        ]
      : [],
  ].flat();

  return {
    paymentValidationErrors,
  };
};
